import { render } from "./InputPostalcode.vue?vue&type=template&id=38e81ff8&scoped=true"
import script from "./InputPostalcode.vue?vue&type=script&lang=js"
export * from "./InputPostalcode.vue?vue&type=script&lang=js"

import "./InputPostalcode.vue?vue&type=style&index=0&id=38e81ff8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e81ff8"]])

export default __exports__